import {Component, OnInit, ViewChild, Optional, ViewContainerRef} from '@angular/core';
import {CoinConfigService} from '../../_services/coinconfig.service';
import {Observable} from 'rxjs/Observable';
import {AsyncPipe} from '@angular/common';
import {DialogService} from 'ng2-bootstrap-modal';
import {EditCoinComponent} from './edit-coin/edit-coin.component';
import {ConfirmComponent} from '../../_common/confirm/confirm.component';
import {DataTableDirective} from 'angular-datatables';
import {Subject} from 'rxjs/Subject';
import {LineBotService} from '../../_services/line-bot.service';
import {AuthenticationService} from "../../_services/authentication.service";
import {UserExceptionCoinModel} from '../../_models/user_except_coin';

@Component({
    selector: 'app-coinconfig',
    templateUrl: './coinconfig.component.html',
    styleUrls: ['./coinconfig.component.css']
})
export class CoinConfigComponent implements OnInit {

    model: any = {};
    isRootAdmin: boolean;
    pairs: Observable<any[]>;
    dataPairs: any[] = [];
    objectPairs: any = {};
    pairId: string;
    confirm: boolean = true;

    markets: Observable<any[]>;
    dataMarkets: any[] = [];
    objectMarkets: any = {};
    marketId: string;

    lineBotAlls: Observable<any[]>;
    line_bot_id: string;

    coinName: string;
    delayTimer: any;
    dtTrigger: Subject<any> = new Subject();
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;

    //declare parameters object
    parameters: any = {};
    //declare callback object
    callback: any = {};
    isRoleUser: any;

    /*
     * filterBy = 2; // load all coin in Bot
     * filterBy = 1; // load active coin in Bot
     * filterBy = 0; // load inactive coin in Bot
     */
    filterBy = 2; // default load all in Bot

    constructor(
        private coinConfigService: CoinConfigService,
        private dialogService: DialogService,
        private lineBotService: LineBotService,
        private authenticationService: AuthenticationService
    ) {
        this.isRoleUser = this.authenticationService.checkRoleUser();
    }

    ngOnInit() {
        this.isRootAdmin = this.isRoleUser.isAdmin;
        this.lineBotAlls = this.isRoleUser.isAdmin
            ? this.lineBotService.getLineBot()
            : this.lineBotService.getAllBotConnected();

        this.registerTable();

        //pairs
        this.pairs = this.coinConfigService.getPairs();
        this.pairs.subscribe(data => {
            this.dataPairs = data;
            data.forEach(element => {
                this.objectPairs[element.id] = element.name;
            });
            this.dtTrigger.next();
        });

        //markets
        this.markets = this.coinConfigService.getMarkets();
        this.markets.subscribe(data => {
            this.dataMarkets = data;
            data.forEach(element => {
                this.objectMarkets[element.id] = element.name;
            });
        });
    }

    registerTable() {
        let self = this;
        var jsonColumnAdmin = [
            {
                title: "コイン名",
                data: "coin_name",
                name: "coin_name",
                className: "all text-justify"
            },
            {
                title: "コインペア名",
                data: "cryptocurrency",
                name: "cryptocurrency",
                render: function (pairId) {
                    return self.objectPairs[pairId];
                },
                className: "all text-justify"
            },
            // {
            //     title: "EMA 1",
            //     data: "ema_period_1",
            //     name: "ema_period_1",
            //     className: "text-right"
            // },
            // {
            //     title: "EMA 2",
            //     data: "ema_period_2",
            //     name: "ema_period_2",
            //     className: "text-right"
            // },
            // {
            //     title: "",
            //     data: function (d) {
            //         return `<button class="btn btn-sm btn-edit">編集</button>`;
            //     },
            //     width: '60px',
            //     className: "all text-center",
            //     orderable: false
            // },
            {
                title: "アカウント設定",
                data: "btn_is_set_bot",
                width: '60px',
                className: "all text-center",
                orderable: false
            },
        ];

        var jsonColumnUser = [
            {
                title: "コイン名",
                data: "coin_name",
                name: "coin_name",
                className: "all text-justify"
            },
            {
                title: "コインペア名",
                data: "cryptocurrency",
                name: "cryptocurrency",
                render: function (pairId) {
                    return self.objectPairs[pairId];
                },
                className: "all text-justify"
            },
            {
                title: "アカウント設定",
                data: "btn_is_set_bot",
                width: '60px',
                className: "all text-center",
                orderable: false
            },
        ];

        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [[0, "desc"]],
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            ajax: function (parameters, callback, settings) {
                parameters["search"]["value"] = self.coinName || '';
                parameters["search"]["pair"] = self.pairId || '';

                if (self.filterBy == 1) {
                    parameters["search"]["active"] = 1;
                } else if (self.filterBy == 0) {
                    parameters["search"]["active"] = 0;
                }

                self.lineBotAlls.subscribe(dataLineBot => {
                    if (dataLineBot && dataLineBot.constructor === Array && dataLineBot.length) {
                        self.coinConfigService.getMarkets().subscribe(dataMarket => {
                            parameters["search"]["market"] = self.marketId || dataMarket[0].id;
                            parameters["search"]["lineBot"] = self.line_bot_id || dataLineBot[0].id;

                            //assign parameters object
                            self.parameters = parameters;
                            //assign callback object
                            self.callback = callback;

                            self.coinConfigService.gets(parameters).subscribe(result => {
                                callback({
                                    draw: parameters['draw'],
                                    data: result.data,
                                    recordsTotal: result.data.length,
                                    recordsFiltered: result.recordsTotal
                                });
                            });
                        });
                    }
                });
            },
            columns: this.isRoleUser.isAdmin ? jsonColumnAdmin : jsonColumnUser,
            rowCallback: (row: Node, data: any[] | Object, index: number) => {
                const self = this;
                $('.btn-edit', row).bind('click', () => {
                    self.openEdit(data);
                });

                $('.btn-set-bot', row).bind('click', () => {
                    data['line_bot_id'] = this.parameters["search"]["lineBot"];
                    if (data['is_active_bot'] == 0) {
                        $('.confirm').data('data', data);
                    } else {
                        self.openSetBot(data);
                        self.openSetBotUser(data);
                    }
                });

                var btn_edit = $(row).find('td').find('.btn-edit');
                var btn_active = $(row).find('td').find('.btn-set-bot');
                btn_edit.css({
                    'background-color': 'deepskyblue',
                    'color': '#fff'
                });
                btn_edit.mouseover(function () {
                    btn_edit.css('opacity', '0.9');
                });
                btn_edit.mouseout(function () {
                    btn_edit.css('opacity', '1');
                });

                if (data['is_active_bot'] == 0) {
                    $(row).css('background-color', '#3c8dbc');

                    var btn_active_bot = $(row).find('td:last').find('.btn-active-bot');
                    btn_active_bot.css({
                        'background-color': 'HotPink',
                        'border-color': 'HotPink'
                    });
                    btn_active_bot.mouseover(function () {
                        btn_active_bot.css('opacity', '0.8');
                    });
                    btn_active_bot.mouseout(function () {
                        btn_active_bot.css('opacity', '1');
                    });
                }
                 if(data['isTemp']){
                    btn_edit.prop( "disabled", true);
                    btn_active.text('待機中');
                    btn_active.css({
                        'background-color': 'green',
                        'color': '#fff',
                        'border-color': 'green',
                        'width': '55px'
                    });
                }
                return row;
            }
        };
    }

    onChange(event) {
        this.pairId = event.target.value;
        this.rerenderDataTable();
    }

    onChangeMarkets(event) {
        this.marketId = event.target.value;
        this.rerenderDataTable();
    }

    valuechange(newValue) {
        this.coinName = newValue;
        this.doSearch();
    }

    doSearch() {
        let self = this;
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(function () {
            self.rerenderDataTable();
        }, 600); // Will do the ajax stuff aft
    };

    openEdit(data) {
        this.dialogService.addDialog(EditCoinComponent, {
            coinId: data.id,
            pairs: this.dataPairs,
            coinName: data.coin_name,
            pair: data.cryptocurrency,
            emaPeriod1: data.ema_period_1,
            emaPeriod2: data.ema_period_2,
        }).subscribe((isAccess) => {
            if (isAccess) {
                this.loadCurrentPage();
            }
        });
    }

    rerenderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    loadCurrentPage() {
        //get parameters and retrive result of current page 
        this.coinConfigService.gets(this.parameters).subscribe(result => {
            //use callback function
            this.callback({
                //retrive draw current
                draw: this.parameters['draw'],
                //retrive data of current page
                data: result.data,
                //retrive number records per page
                recordsTotal: result.data.length,
                //retrive total records
                recordsFiltered: result.recordsTotal
            });
        });
    }

    openSetBot(data) {
        if (this.isRoleUser.isAdmin) {
            this.coinConfigService.setBot(data).subscribe(data => {
                if (!data.error) {
                    this.loadCurrentPage();
                } else {
                    alert(data.message);
                }
            }, error => {
                alert(error.json().message);
            });
        }
    }

    openSetBotUser(data) {
        if (!this.isRoleUser.isAdmin) {
            this.coinConfigService.setBotUserExceptCoin(data).subscribe(data => {
                if (!data.error) {
                    this.loadCurrentPage();
                } else {
                    alert(data.message);
                }
            });
        }
    }

    confirmActive() {
        const data = $('.confirm').data('data');
        data.pair = this.objectPairs[data.cryptocurrency];
        this.coinConfigService.activeCoinTemp(data).subscribe(data => {
            if (!data.error) {
                this.confirm = false;
            } else {
                alert(data.message);
                this.confirm = true;
            }
        });
    }

    onChangeLineBot(event) {
        this.line_bot_id = event.target.value;
        this.rerenderDataTable();
    }

    onChangeFilter(event) {
        this.filterBy = event.target.value;
        this.rerenderDataTable();
    }

    onClose() {
        this.confirm = true;
        this.rerenderDataTable();
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/coinconfig/coinconfig.component.ts